import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Plan the lift, not the lift plan",
    body: "Every mobilisation starts on paper. Load charts, weather windows, exclusion zones and rescue plans are signed off before a crew steps on deck.",
    img: "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwc3RlZWwlMjBoZWF2eSUyMGxpZnQlMjBlbmdpbmVlcmluZ3xlbnwwfHx8fDE3ODU1MjgwOTd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "02",
    title: "Ticketed crews only",
    body: "Operators, riggers and banksmen carry current offshore medicals, BOSIET and stage-appropriate lifting certifications. No exceptions, no shortcuts.",
    img: "https://images.unsplash.com/photo-1622612023350-b15f063eabe6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxjZXJ0aWZpZWQlMjBzYWZldHklMjBvZmZzaG9yZSUyMHdvcmtlciUyMGhlbG1ldHxlbnwwfHx8fDE3ODU1MjgwOTd8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    n: "03",
    title: "Zero-harm is the baseline",
    body: "Stop-work authority sits with every hand on the job. If a lift doesn't feel right, it doesn't happen. Safety is measured, not assumed.",
    img: "https://images.unsplash.com/photo-1644238017851-21f15062c213?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMGNhYmxlJTIwd2lyZSUyMHJvcGUlMjBoZWF2eXxlbnwwfHx8fDE3ODU1MjgxMDh8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const Manifesto = () => {
  const [active, setActive] = useState(0);

  return (
    <section
      id="method"
      data-testid="method-section"
      className="w-full px-6 md:px-12 py-24 md:py-40 bg-[#0A111D] border-t border-white/10"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
        <Reveal className="md:col-span-3">
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-accent">
            [ 002 — Method ]
          </span>
        </Reveal>
        <Reveal className="md:col-span-9" delay={0.1}>
          <h2 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
            How we keep steel<br />
            <span className="text-[#64748B]">in the air.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 border-t border-white/10">
          {chapters.map((c, i) => (
            <div
              key={c.n}
              data-testid={`chapter-${c.n}`}
              onMouseEnter={() => setActive(i)}
              className={`group grid grid-cols-12 gap-4 py-8 md:py-10 border-b border-white/10 cursor-default transition-colors duration-300 ${
                active === i ? "bg-[#141C2A]" : ""
              }`}
            >
              <span className="col-span-2 font-mono text-lg md:text-2xl text-accent">{c.n}</span>
              <div className="col-span-10 pr-4">
                <h3
                  className={`font-display text-2xl md:text-4xl tracking-tight mb-3 transition-colors duration-300 ${
                    active === i ? "text-white" : "text-[#64748B]"
                  }`}
                >
                  {c.title}
                </h3>
                <p className="text-[#94A3B8] leading-relaxed text-sm md:text-base max-w-2xl">
                  {c.body}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="lg:col-span-5 relative">
          <div className="sticky top-28 h-[340px] md:h-[520px] overflow-hidden border border-white/10">
            <AnimatePresence mode="wait">
              <motion.img
                key={active}
                src={chapters[active].img}
                alt={chapters[active].title}
                initial={{ opacity: 0, scale: 1.08 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="h-full w-full object-cover"
              />
            </AnimatePresence>
            <div className="absolute inset-0 bg-[#050B14]/25" />
            <span className="absolute bottom-5 left-5 font-mono text-xs tracking-[0.2em] uppercase text-white/80">
              Fig. {chapters[active].n}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
